// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".timeline-list[data-v-50ae38e2]{margin-bottom:4rem}.timeline-list[data-v-50ae38e2]:before{height:calc(100% + 10px)}", ""]);
// Exports
module.exports = exports;
